import * as React from 'react';

import {PeanutFormPreview} from '../form-page/peanut-form-preview/peanut-form-preview';

type Props = {
    match?: any;
    publicFormId?: string;
};

export function FormPreview(props: Props) {
    const getPublicFormId = () => {
        if (props.publicFormId) {
            return props.publicFormId;
        }

        if (props.match && props.match.params.formId) {
            return props.match.params.formId;
        }

        return null;
    };

    const publicFormId = getPublicFormId();

    if (!publicFormId) {
        return null;
    }

    return (
        <PeanutFormPreview
            publicFormId={publicFormId}
            instanceId={NutshellFrontendSettings.instanceId}
            getUnpublishedVersion={true}
        />
    );
}
